import arrayServiceFactory from '../../../types/array/array.service';
import { renderChipsFactory } from './renderChipsFactory/renderChipsFactory';
import FbArrayCellEditorClass from '../cells/fb-array-cell-editor.class';

const arrayService = arrayServiceFactory();

export default function arrayCellService({ FbCellEditor }) {
  return function generate(viewField, engineApi, engineGridApi) {
    const column = engineApi.cell.setCommonAttributes(viewField, engineApi, engineGridApi);
    const parentRegister = engineApi.utils.getRegister(viewField.model); // CAB.LIN.DTOS -> LIN

    const renderChipsFn = renderChipsFactory(viewField, engineApi);
    const templateFn = templateFnFactory(viewField, engineApi);
    // renderer
    column.renderer = 'array';
    column.renderChipsFn = renderChipsFn;

    // editor
    column.editor = FbArrayCellEditorClass(FbCellEditor, {}, { renderChipsFn });
    column.detail = {
      compile: true,
      templateFn,
      scope: ({ data }) => {
        return { [parentRegister]: data }; // permite copiar la linea en el scope.LIN
      },
    };

    return column;
  };
}

function templateFnFactory(viewField, engineApi) {
  let template;
  return () => {
    if (!template) {
      template = arrayService(viewField, engineApi).toString();
    }
    return template;
  };
}
